module.exports = __webpack_public_path__ + "front/img/content3.eb3ec645.png";